import { createSlice } from '@reduxjs/toolkit'
import { SIGN_IN_STATE } from '../../constants'

export const onLoginReducer = (state, { payload }) => {
  const { token, user } = payload

  let admin = false
  if (user.roles?.length > 0) {
    user.roles.forEach(role => {
      if (role.name === 'admin') {
        admin = true
      }
    })
  }

  const newState = {
    ...state,
    isLoggedIn: true,
    token,
    user,
    admin
  }
  return newState
}

export const onHasErrorReducer = (state, { payload }) => {
  const { hasError, invalidToken } = payload
  const newState = {
    ...state,
    hasError,
    invalidToken
  }
  return newState
}

export const onSaveUserReducer = (state, { payload }) => {
  const { user } = payload

  const newState = {
    ...state,
    user
  }
  return newState
}

export const setAgeGateReducer = (state, { payload }) => {
  const { ageGate } = payload
  const newState = {
    ...state,
    ageGate
  }
  return newState
}

export const onSavePreferencesReducer = (state, { payload }) => {
  const { preferences } = payload

  const newState = {
    ...state,
    user: {
      ...state.user,
      preferences
    }
  }
  return newState
}

export const saveAgeInformationReducer = (state, { payload }) => {
  const { persona, ageOfConsent, isYoungLearner } = payload

  const newState = {
    ...state,
    user: {
      ...state.user,
      persona,
      ageOfConsent,
      preferences: {
        isYoungLearner
      }
    }
  }

  return newState
}

export const onSaveGoogleInfoReducer = (state, { payload }) => {
  const { uid, email } = payload

  const newState = {
    ...state,
    user: {
      ...state.user,
      email
    },
    uid
  }

  return newState
}

export const onSaveGoogleSyncReducer = (state, { payload }) => {
  const { googleToken } = payload

  const newState = {
    ...state,
    user: {
      ...state.user,
      googleToken
    }
  }

  return newState
}

export const logoutReducer = (state) => {
  const newState = {
    ...state,
    isLoggedIn: false,
    token: null,
    uid: null,
    hasError: false,
    inValidToken: false,
    signInState: SIGN_IN_STATE.KIOSK,
    admin: false,
    classType: '',
    user: {
      email: '',
      username: '',
      password: '',
      userId: '',
      firstName: '',
      lastName: '',
      persona: '',
      provider: '',
      preferences: {
        eduConsent: false,
        language: '',
        privacyPolicy: false,
        signature: null,
        toc: false
      },
      organizationId: null
    }
  }
  return newState
}

export const reloadUserReducer = (state, { payload }) => {
  const { user } = payload

  const newState = {
    ...state,
    user
  }
  return newState
}

export const setSignInStateReducer = (state, { payload }) => {
  const signInState = payload

  return {
    ...state,
    signInState
  }
}

export const onSetStudentClassType = (state, { payload }) => {
  const { classType } = payload

  return {
    ...state,
    classType
  }
}

const dashboardSlice = createSlice({
  name: 'authentication',
  initialState: {
    isLoggedIn: false,
    signInState: SIGN_IN_STATE.KIOSK,
    classType: '',
    user: {
      email: '',
      accountInfo: {},
      username: '',
      password: '',
      userId: '',
      firstName: '',
      lastName: '',
      persona: '',
      provider: '',
      preferences: {
        eduConsent: false,
        language: '',
        privacyPolicy: false,
        signature: null,
        toc: false
      },
      organizationId: null
    },
    token: null,
    ageGate: 16,
    uid: null,
    admin: false
  },
  reducers: {
    logout: logoutReducer,
    onLogin: onLoginReducer,
    onSaveUser: onSaveUserReducer,
    reloadUser: reloadUserReducer,
    setAgeGate: setAgeGateReducer,
    saveAgeInformation: saveAgeInformationReducer,
    onSavePreferences: onSavePreferencesReducer,
    onSaveGoogleInfo: onSaveGoogleInfoReducer,
    onSaveGoogleSync: onSaveGoogleSyncReducer,
    setSignInState: setSignInStateReducer,
    onHasError: onHasErrorReducer,
    setStudentClassType: onSetStudentClassType
  }
})

const { actions, reducer } = dashboardSlice

export const {
  logout,
  onLogin,
  onSaveUser,
  onHasError,
  reloadUser,
  setAgeGate,
  saveAgeInformation,
  onSavePreferences,
  onSaveGoogleInfo,
  onSaveGoogleSync,
  onSetRole,
  setSignInState,
  setStudentClassType
} = actions

export default reducer
